import _ from '@lodash';
import { useState, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { AgGridReact } from 'ag-grid-react';
import '../../../../styles/ag-custom.css';
import useRouter from '@fuse/hooks/useRouter';
import axios from "@fuse/utils/axios";
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'ag-grid-community/styles/ag-theme-material.css';
import 'styles/ag-grid-header-style.css';
import CustomFilter from '@fuse/components/AgGridFilterGroupView/components/CustomFilter';
import AgGridFilterGroupView from '@fuse/components/AgGridFilterGroupView';
import { setfilterlist, setrowGroupModel } from '../store/filterParamsReducer';
import { convertToTimezone } from 'helper/common';

function ListView(props) {
	const table_name = "ASSETSTATUS";
	const router = useRouter();
	const gridRef = useRef();
	const dispatch = useDispatch();
	const [filterApplied, setFilterApplied] = useState(false);
	const [aggridParam, setAggridParam] = useState([])
	const [windowHeight, setWindowHeight ]  = useState(window.innerHeight - 290);
	const [groupByArr, setGroupByArr] = useState([])
  	const [rowGroupPanelShow, setRowGroupPanelShow] = useState('never');
	const skipHeader = [
		"id", "host_id", "created_at", "updated_at"
	]
	const frameworkComponents = {
		customFilter: CustomFilter,
	};
	// const query_data = useSelector((state) => state.reportApp.reportViewDialogReducer.quick_filter);
	const tableHeaders = [
		"problem_id", "serial_no", 'manufacturer_name', 'model_name', 'model_no', 'user_name', 'device_name', "host_name", "event_severity", "event Date & Time", "recovery_time",
		"event_status", "alert_subject", "event_duration", "asset_id",
	  ];
	async function getIncidents(params){
		try {
			const {startRow, endRow, filterModel, sortModel, rowGroupCols, groupKeys, pivotMode} = params.request;
			axios.post(`/zabbix/get-all-incident`,{
				dataSourceParams: {
				  startRow, endRow, filterModel, sortModel, rowGroupCols, groupKeys, pivotMode
				}
			}).then((res) => {
				const rows = formatData(res.data.data.rows);
				const { lastRow } = res.data.data;

				(params.success || params.successCallback)?.({
					rowData: rows,
					rowCount: lastRow ?? rows.length,
				});
				if(rows.length === 0) gridRef.current.api.showNoRowsOverlay();
			    else gridRef.current.api.hideOverlay();
			  }).catch((err) => {
				console.error("error", err);
				(params.fail || params.failCallback)?.();
			  })
			// const res = await axios.get("/zabbix/get-all-incident");
			// const { incidents } = res.data.data;
			// setIncidents(formatData(incidents));
		} catch (err) {
			console.log(err);
		}
	}

	function formatData(data){
		return data.map((item) => {
			return {
				problem_id: item.problem_id,
				serial_no: item.serial_no,
				host_name: item.host_name,
				event_severity: item.event_severity,
				'event Date & Time': item?.problem_time ? convertToTimezone(item?.problem_time, 'date') : '',
				recovery_time: item.recovery_time ? convertToTimezone(item.recovery_time, 'date') : '',
				event_status: item.event_status,
				alert_subject: item.alert_subject,
				event_duration: item.event_duration,
				asset_id: item.asset_id || null,
				manufacturer_name: item?.manufacturer_name,
				model_no: item?.model_no,
				user_name: item?.user_name,
				device_name: item?.device_name,
				model_name: item?.model_name
			}
		})
	}

	const datasource = {
		getRows(params) {
		  // Call the function to fetch asset data from the server.
		  getIncidents(params)
		}
	  };

	const onGridReady = (params) => {
		gridRef.current = params;
		setAggridParam(params)
		params.api.sizeColumnsToFit()
		// setGridApi(params)
		if (router.query.report_name === undefined) {
		  // params?.api.setGridOption('serverSideDatasource', datasource);
		  loadInitialState(params)
		  dispatch(setfilterlist({}));
		  // dispatch(setrowGroupModel([]));
		  // loadInitialState(params);
		  dispatch(setrowGroupModel([]));
		}
		else {
		  setRowGroupPanelShow('always')
		  getReport(params);
		  // loadInitialState(params)
		}
	}
	
	function onFilterChanged(event){
		const rows = event.api.getFilterModel();
		// dispatch(setfilterlist(rows));
		// validation for no-overlay 
		dispatch(setfilterlist(rows));
		saveView("N/A", rows,gridRef.current.filterModelArr)
		const total_rows = event.api.getDisplayedRowCount();

		if(total_rows === 0 ){
			event.api.showNoRowsOverlay();
		}else{
			event.api.hideOverlay();
		}
	}

	function getReport(event){
		const {report_name} = router.query;
		const table_name = "asset status";
		axios.get(`/reports/view-report?table_name=${table_name}&report_name=${report_name}`)
		.then(results=>{
			const model = JSON.parse(results.data.data.filter);
			event.api.setFilterModel(model);
			const row_model = JSON.parse(results.data.data.row_model);
			event.api?.getColumnState(row_model);
        	event?.api.setGridOption('serverSideDatasource', datasource);
		})
		.catch(err=>{
			console.log(err);
		})
	}

	function loadInitialState (params){
        if(!table_name) return;
        axios.get(`/user-view/show-view-order?table_name=${table_name}`)
        .then(results=>{
            const { data } = results.data;
			if (data !== null) {
				const order = JSON.parse(data.order);
				const filter = JSON.parse(data?.filter);
				if (Object.keys(filter || {})?.length) {
					setFilterApplied(true)
				  }
				gridRef.current = { ...gridRef.current, filterModelArr: filter }
				params?.api?.getColumnState(order);
				  params.api.setFilterModel(filter);
				}
				// gridRef.current.api.setFilterModel(filterModel);
				// params?.api.setGridOption('serverSideDatasource', datasource);
        })
        .catch(err=>{
            console.log(err);
        }).finally(() => {
			params?.api.setGridOption('serverSideDatasource', datasource);
		  })
    }

    const saveView = (rows, filter) => {
        if(!table_name) return;
		let payload = {}
		if(rows == 'N/A'){
			payload = {
				filter:  JSON.stringify(filter),
				table_name
			}
		}else{
			payload = {
				order:  JSON.stringify(rows),
				table_name
			}
		}
		axios.post('/user-view/save-view-order',payload)
		.then(()=>{
			console.log('view updated')
		})
		.catch(err=>{
			console.log(err);
		})
    }

    const onColumnMoved = (params) => {
        const rows = params.api?.getColumnState();
        saveView(rows);
		dispatch(setrowGroupModel(rows))
    }

    function onColumnVisible(params){
		const rows = params.api?.getColumnState();
		const total_no_of_columns = rows.length;
		let total_hidden_columns = 0;
		rows.forEach(row=>{
			const { hide } = row;
			if(hide) {
				++total_hidden_columns;
			}
		});
		if( total_hidden_columns < total_no_of_columns){
			saveView(params.api.getColumnState());
		}
	}

	function onColumnRowGroupChanged(event){
		const {report_name} = router.query;
		if(report_name == undefined){
			const rows = event.api?.getColumnState();
			const first_row = rows[0];	
			if(first_row.colId !== 'ag-Grid-AutoColumn'){
				saveView(rows);
				dispatch(setrowGroupModel([]));
			}else{
				dispatch(setrowGroupModel(rows));
			}
		}
		if(event.columns.length == 0) {
			setGroupByArr([])
		}else{
			setGroupByArr(event.columns)
		}
	}

	const onColumnPinned = (params) =>{
		if(router.query.report_name == undefined) {
			const rows = params.api?.getColumnState();
			saveView (rows);
		}
	}

	function redirectToAssetProfile(params) {
		if(!params.data.asset_id) return
    	router.push(`/assets-list/${params.data.asset_id}`);

	}
	const generateHeaderLabel = (header) => {
		if(header == 'problem_id'){
			return 'Problem Number'
		} if(header == 'serial_no'){
			return 'Serial Number'
		} if(header == 'event_subject'){
			return 'Problem'
		} if(header == 'event_status'){
			return 'Status'
		} if(header == 'event_severity'){
			return 'Severity'
		} if (header === 'user_name') {
			return 'Customer Name'
		}
		return header.split('_').map(word => {
			return word.charAt(0).toUpperCase() + word.substring(1)
		}).join(' ')
	}

	// useEffect(()=>{
	//		gridRef.current.api?.setQuickFilter(
		//	query_data
		// );
	// },[query_data])

	function onSortChanged(params) {
		const rows = params.api?.getColumnState();
		if (router.query.report_name == undefined) {
		  dispatch(setrowGroupModel(rows))
		  saveView(rows);
		}
	
	  }

	return (	
		<>
		<AgGridFilterGroupView
				tableRef={gridRef} 
				setRowGroupPanelShow={setRowGroupPanelShow} 
				groupByArrFromList ={ groupByArr }
				tableName= "Insight log"
				displayTableName="Insights Log"
			/>
			<div
				className="ag-theme-alpine" 
				style={{
					width: "100%",
					height:windowHeight+105,
					fontSize:'11px'
				}}
			>
				<AgGridReact
					ref={gridRef}
					theme="legacy"
					onGridReady = { onGridReady }
					animateRows
					// rowData = {props.endUsersAccounts}
					rowHeight={30}
					headerHeight={44}
					rowModelType='serverSide'
					serverSideStoreType="partial"
					defaultColDef={{
						enableRowGroup:true,
						sortable: true,
						resizable: true
					}}
					defaultExcelExportParams={{
					sheetName: 'Dalos-Source'
					}}
					pagination
					overlayNoRowsTemplate="<span>No Result Found</span>"

					// Row Grouping conditions
					showOpenedGroup
					suppressDragLeaveHidesColumns
					suppressMakeColumnVisibleAfterUnGroup
					rowGroupPanelShow={ rowGroupPanelShow }

					onColumnMoved = { onColumnMoved }
					onColumnPinned = { onColumnPinned }
					onColumnVisible = { onColumnVisible }

					groupHeaderHeight ={1}
					components={frameworkComponents}
					floatingFiltersHeight = {40}
					onSortChanged={onSortChanged}
					// get filter model
					onFilterChanged = { onFilterChanged }	
					
					// on column group changed
					onColumnRowGroupChanged={onColumnRowGroupChanged}
					columnDefs={[
						...tableHeaders
							.filter((header) => !skipHeader.includes(header))
							.map((header) => {
								return {
									field: header,
									sortable: true,
									minWidth: 200,
									filter: 'agTextColumnFilter',
									flex: 1,
									headerName: generateHeaderLabel(header),
									headerComponent: (props) => (CustomFilter(props, header, gridRef)),
									cellRenderer: (event) => {
										if(event.colDef.field === "serial_no"){
											return (<a
												style={{
													height: '10px',
													width: '10px',
													color: 'black',
													cursor: 'pointer',
													marginTop: '2px',
													borderRadius: '50%',
													// display: 'inline-block',
													display: 'flex',
													alignItems: 'center',
													gap: '10px'
												}}
												onClick={() => redirectToAssetProfile(event)}
												// variant="subtitle1"
											>
												<><span>{event.value}</span></>
											</a>)
										}
										return (<span>{event.value}</span>)

									}
								};
							})
					]}
				/>
			</div>
		</>
	);
}

export default ListView
